// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5968":"6cec2565","9224":"c7951915"}[chunkId] + ".chunk.css";
};